// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/3/2023
 */

 .Hours_headingContainer__uZHIV {
    display: flex;
    justify-content: space-between;
  }
  
  .Hours_closeButton__kuKma {
    padding: 0.2rem;
    border: 1px #47C2BB solid;
    color: #47C2BB;
  }
  
  .Hours_formItem__0nZSx {
    margin-top: 1rem;
  }
  
  .Hours_formLabel__kBo\\+L {
    font-weight: 600;
  }
  
  .Hours_formInput__zA02z {
    margin-top: 0.3rem;
  }
  
  .Hours_validation__QKhEE {
    color: red;
  }
  
  .Hours_buttonContainer__j3yD5 {
    margin-top: 2rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
  }
  
  .Hours_submitButton__VBHlc {
    width: 10rem;
  }`, "",{"version":3,"sources":["webpack://./src/Components/NoHours/Hours.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;CAED;IACG,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 31/3/2023\r\n */\r\n\r\n .headingContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  .closeButton {\r\n    padding: 0.2rem;\r\n    border: 1px #47C2BB solid;\r\n    color: #47C2BB;\r\n  }\r\n  \r\n  .formItem {\r\n    margin-top: 1rem;\r\n  }\r\n  \r\n  .formLabel {\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .formInput {\r\n    margin-top: 0.3rem;\r\n  }\r\n  \r\n  .validation {\r\n    color: red;\r\n  }\r\n  \r\n  .buttonContainer {\r\n    margin-top: 2rem;\r\n    margin-bottom: 1rem;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .submitButton {\r\n    width: 10rem;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headingContainer": `Hours_headingContainer__uZHIV`,
	"closeButton": `Hours_closeButton__kuKma`,
	"formItem": `Hours_formItem__0nZSx`,
	"formLabel": `Hours_formLabel__kBo+L`,
	"formInput": `Hours_formInput__zA02z`,
	"validation": `Hours_validation__QKhEE`,
	"buttonContainer": `Hours_buttonContainer__j3yD5`,
	"submitButton": `Hours_submitButton__VBHlc`
};
export default ___CSS_LOADER_EXPORT___;
